/**
 * @author Mevan Nirosh
 * @version 1.0
 * @since 6/26/2023
 */

import axios from "axios";

const axiosResApiInstance = axios.create({
  baseURL: process.env.REACT_APP_RES_API_URL,
  headers: {
    "Accept-Version": "1.0",
  },
})

// export const commonApi = (method, url, data, config) => {
//   return axios({
//     method: method,
//     url: process.env.REACT_APP_RES_API_URL + url,
//     data: data,
//     ...config,
//   });
// };

export default axiosResApiInstance;
